import React, { useMemo } from 'react';
import { useAuthContext } from '../context/AuthContext';
import { useMyBouts } from '../hooks/useMyBouts';
import ProfileSubNav from '../components/ProfileSubNav';
import BoutCard from '../components/BoutCard';
import './BoutHistoryPage.css';

export default function BoutHistoryPage() {
  const { user } = useAuthContext();
  const { myBouts, loading } = useMyBouts();

  const activeBouts = myBouts.filter((b) => b.status === 'active');
  const completedBouts = myBouts.filter((b) => b.status === 'completed');

  const boutRecord = useMemo(() => {
    if (!user || completedBouts.length === 0) {
      return { total: 0, wins: 0, losses: 0, winPct: '0%' };
    }
    const wins = completedBouts.filter((b) => b.winnerUid === user.uid).length;
    const losses = completedBouts.length - wins;
    const winPct = completedBouts.length > 0
      ? `${Math.round((wins / completedBouts.length) * 100)}%`
      : '0%';
    return { total: completedBouts.length, wins, losses, winPct };
  }, [completedBouts, user]);

  return (
    <div className="profile-page">
      <h1>Bout History</h1>
      <ProfileSubNav />

      {/* Bout Record Summary */}
      <div className="bout-history-record">
        <div className="bout-record-item">
          <span className="bout-record-value">{boutRecord.total}</span>
          <span className="bout-record-label">Total Bouts</span>
        </div>
        <div className="bout-record-item">
          <span className="bout-record-value bout-record-wins">{boutRecord.wins}</span>
          <span className="bout-record-label">Wins</span>
        </div>
        <div className="bout-record-item">
          <span className="bout-record-value bout-record-losses">{boutRecord.losses}</span>
          <span className="bout-record-label">Losses</span>
        </div>
        <div className="bout-record-item">
          <span className="bout-record-value">{boutRecord.winPct}</span>
          <span className="bout-record-label">Win %</span>
        </div>
      </div>

      {loading ? (
        <div className="bout-history-empty">Loading bouts...</div>
      ) : activeBouts.length === 0 && completedBouts.length === 0 ? (
        <div className="bout-history-empty">
          <p>No bouts yet. Head to the Arena to create or join one!</p>
        </div>
      ) : (
        <>
          {/* Active Bouts */}
          {activeBouts.length > 0 && (
            <div className="bout-history-section">
              <div className="bout-history-section-header">
                <h2>Active Bouts</h2>
                <span className="bout-history-count">{activeBouts.length}</span>
              </div>
              {activeBouts.map((bout) => (
                <BoutCard
                  key={bout.id}
                  bout={bout}
                  currentUid={user?.uid}
                />
              ))}
            </div>
          )}

          {/* Completed Bouts */}
          {completedBouts.length > 0 && (
            <div className="bout-history-section">
              <div className="bout-history-section-header">
                <h2>Completed Bouts</h2>
                <span className="bout-history-count">{completedBouts.length}</span>
              </div>
              {completedBouts.map((bout) => (
                <BoutCard
                  key={bout.id}
                  bout={bout}
                  currentUid={user?.uid}
                />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
